export default {
  get: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/my/welcome-widget-tasks'),
  update: (widgetId, data) => $nuxt.$axios.post($nuxt.$api.host + '/my/welcome-widget-tasks/' + widgetId, data),
  // take the data and post a JSON representation of the data to the endpoint - current maximum size of the payload is 2000 characters
}
